import ApplicationController from './application_controller'
import { animate } from 'animejs'

export default class extends ApplicationController {

	static values = {
		onlyActiveInputs: { type: Boolean, default: true }
	}

	connect() { this.disableInputs() }

	nextList(event) {
		const clickedElement = event.currentTarget
		const hideListElement = clickedElement.closest('ul')
		this.hideList(hideListElement)

		const nextListId = event.params.nextListId
		const nextListElement = document.getElementById(nextListId)
		this.showList(nextListElement)

		if (this.onlyActiveInputsValue) {
			this.disableInputs()
			this.enableActiveInputs(nextListElement)
		}
	}

	hideList(listElement) {
		animate(listElement, {
			left: '-240px',
			opacity: 0,
			duration: 400,
			easing: 'easeOutQuad',
			onComplete: () => { listElement.classList.add('d-none') }
		})
	}

	showList(listElement) {
		const listElements = Array.from(this.element.querySelectorAll('ul'))

		listElement.style.left = '240px'

		animate(listElement, {
			left: '0px',
			opacity: 1,
			delay: 400,
			duration: 400,
			easing: 'easeOutQuad',
			onBegin: () => {
				listElements.forEach( e => e.classList.add('d-none') )
				listElement.classList.remove('d-none')
			}
		})
	}

	disableInputs() {
		Array.from(this.element.querySelectorAll('input, select'))
			.forEach( element => element.disabled = true )
	}

	enableActiveInputs(listElement) {
		Array.from(listElement.querySelectorAll('input, select'))
			.forEach( element => element.disabled = false )
	}
}
